export default {
  setYearly(state, { data }) {
    state.yearly = data;
  },
  setMonthly(state, { data }) {
    state.monthly = data;
  },
  setTopYear(state, { data }) {
    state.topYear = data;
  },
  setTopDay(state, { data }) {
    state.topDay = data;
  },
  setTopMonth(state, { data }) {
    state.topMonth = data;
  },  
}